import React from 'react';
import styled, { css } from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Points, textSize } from '@styles';

export const SelfCheck = ({ html = '', children }) => (
  <>{html ? <View dangerouslySetInnerHTML={{ __html: html }} /> : <View>{children}</View>}</>
);

export const styles = {
  container: css`
    width: 100%;
    border: 1px solid ${Colors.dark_300};
    padding: 20px;
    margin: 70px 0;
    color: ${Colors.main_dark};

    @media ${Points.tablet_landscape} {
      width: 600px;
      margin: 70px auto;
    }

    @media ${Points.laptop_wide} {
      width: 640px;
    }

    @media ${Points.fullhd} {
      width: 690px;
    }

    .self-check-headerwrap {
      display: flex;
      justify-content: space-between;
      gap: 15px;
      margin-bottom: 20px;
      flex-direction: column-reverse;

      @media ${Points.tablet_portrait} {
        flex-direction: row;
      }
    }

    .self-check-header {
      margin: 0;
      ${textSize('subtitle')};
      font-weight: 400;
    }

    .label {
      width: fit-content;
      height: min-content;
      padding: 5px 10px 6px;
      background-color: ${Colors.blue_200};
      border-radius: 20px;
      color: ${Colors.blue_900};
      ${textSize('description_2')};
      margin-left: auto;

      @media ${Points.tablet_portrait} {
        margin-left: 0;
      }
    }

    .self-check-variant-wrap {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: 10px;
    }

    .self-check-variant {
      display: block;
      width: 100%;
      padding: 10px;
      border-radius: 9px;
      border: 1px solid ${Colors.dark_300};
      cursor: pointer;
      transition: all 0.3s;
    }

    .self-check-variant:hover {
      background-color: ${Colors.beige_100};
      border-color: ${Colors.beige_100};
    }

    input[type='radio']:checked + .self-check-variant {
      background-color: #f2dcdc;
      border-color: #f2dcdc;
      padding-left: 44px;
      position: relative;
    }

    input[type='radio']:checked + .self-check-variant::before {
      content: '';
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24'><rect width='24' height='24' rx='12' fill='%23D26A6A'/><path d='M8.23529 16L15.7647 8M8 8.23529L16 15.7647' stroke='white' stroke-linecap='round'/></svg>");
      background-size: cover;
    }

    input[data-answer='suggestion17854']:checked + label.self-check-variant {
      background-color: #d8ebdd;
      border: 1px solid #d8ebdd;
      padding-left: 44px;
    }

    input[data-answer='suggestion17854']:checked + label.self-check-variant::before {
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3e%3crect width='24' height='24' rx='12' fill='%237F9E8C'/%3e%3cpath d='M6.33203 11.668L9.9987 15.3346L17.6654 7.66797' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
    }
  `,
};

export const View = styled.div`
  ${styles.container};
`;
